var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { CircularProgress, Stack } from "@mui/material";
import { AuthProvider } from "./context/AuthProvider";
import { RouterManager } from "./router/RouterManager";
export var App = function () {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    setTimeout(function () {
        setLoading(false);
    }, 750);
    return (_jsx(AuthProvider, { children: loading ? (_jsx(Stack, __assign({ alignItems: "center", marginTop: "4rem" }, { children: _jsx(CircularProgress, {}) }))) : (_jsx(Stack, { children: _jsx(RouterManager, {}) })) }));
};
